module.exports = __webpack_public_path__ + "4eead551cc613d4bf2f2e33970b57a8e.svg";